import axios from "axios";
import moment from "moment";
import React from "react";
import { useQuery } from "react-query";
import { accessToken } from "../../../../views/apps/ecommerce/utils/utils";
import { Link } from 'react-router-dom'
import "./style.css"
const getPoint = (dayFirstMonth, dayLastMonth) => {
  const token = accessToken();

  const request = async () => {
    const config = {
      method: "get",
      url: `https://wallet.cloodo.com/index.php/points/total?from=${dayFirstMonth}&to=${dayLastMonth}`,
      headers: {
        "Auth-Key": token,
      },
    };
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      throw new Error(error);
    }
  };
  const query = useQuery(
    ["numberPoint", { dayFirstMonth, dayLastMonth }],
    request,
    {
      refetchOnWindowFocus: false,
    }
  );
  return query;
};

const Point = () => {
  const currentDate = new Date();
  const dayFirstMonth = moment(
    new Date(currentDate.getFullYear(), currentDate.getMonth(), 1).toString()
  ).format("YYYY-MM-DD");

  const nextMonth = currentDate.getMonth() + 1;
  const dayLastMonth = moment(
    new Date(currentDate.getFullYear(), nextMonth, 0).toString()
  ).format("YYYY-MM-DD");

  const { data: dataPoint, isLoading: isLoadingPoint } = getPoint(
    dayFirstMonth,
    dayLastMonth
  );

  return (
    <>
      <div className="top-point">
        <Link to="/apps/point">
          <div className="d-flex align-item-center" >
            <span style={{color:"#7E7B8A"}}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-wallet2"
                viewBox="0 0 16 16"

              >
                <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z" />
              </svg>
            </span>
            <span className="Wallet" >
              {/* {dataPoint ? dataPoint?.point : "0"} */}
              Wallet
            </span>
          </div>
        </Link>
      </div>
    </>
  );
};

export default Point;
